/**
 * PSE financial institutions (código del banco → nombre), per PayZen's published
 * "Lista de bancos para PSE". Used to build Tikipal's own bank selector; the chosen
 * code is sent as acquirerTransientData.PSE.financialInstitutionCode:[code] so PayZen
 * skips its bank-selection screen.
 *
 * NOTE: this is a static snapshot of PayZen's published list. It should be refreshed
 * periodically from the official source (ideally served from an endpoint) so new or
 * renamed institutions stay in sync.
 */
export type PseBank = { code: string; name: string };

export const PSE_BANKS: PseBank[] = [
  { code: '1040', name: 'BANCO AGRARIO' },
  { code: '1052', name: 'BANCO AV VILLAS' },
  { code: '1013', name: 'BANCO BBVA COLOMBIA S.A.' },
  { code: '1032', name: 'BANCO CAJA SOCIAL' },
  { code: '1066', name: 'BANCO COOPERATIVO COOPCENTRAL' },
  { code: '1051', name: 'BANCO DAVIVIENDA' },
  { code: '1001', name: 'BANCO DE BOGOTA' },
  { code: '1023', name: 'BANCO DE OCCIDENTE' },
  { code: '1062', name: 'BANCO FALABELLA' },
  { code: '1012', name: 'BANCO GNB SUDAMERIS' },
  { code: '1006', name: 'BANCO ITAU' },
  { code: '1047', name: 'BANCO MUNDO MUJER S.A.' },
  { code: '1060', name: 'BANCO PICHINCHA S.A.' },
  { code: '1002', name: 'BANCO POPULAR' },
  { code: '1058', name: 'BANCO PROCREDIT' },
  { code: '1065', name: 'BANCO SANTANDER COLOMBIA' },
  { code: '1007', name: 'BANCOLOMBIA' },
  { code: '1059', name: 'BANCAMIA S.A.' },
  { code: '1009', name: 'CITIBANK' },
  { code: '1551', name: 'DAVIPLATA' },
  { code: '1507', name: 'NEQUI' },
  { code: '1019', name: 'SCOTIABANK COLPATRIA' },
];

// Normaliza para búsqueda: minúsculas + SIN tildes/diacríticos (NFD + strip combining marks).
const normalize = (s: string): string =>
  (s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export function searchPseBanks(query: string): PseBank[] {
  const raw = (query || '').trim();
  if (!raw) return PSE_BANKS;
  const q = normalize(raw);
  // Nombre (sin mayúsculas ni tildes) o por código real del banco.
  return PSE_BANKS.filter((b) => normalize(b.name).includes(q) || b.code.includes(raw));
}

export function getPseBankByCode(code?: string | null): PseBank | undefined {
  if (!code) return undefined;
  return PSE_BANKS.find((b) => b.code === code);
}
